import React, { useState } from 'react';
import Section from '../components/ui/Section';
import { faqs } from '../data/faq';
import { ChevronDown } from 'lucide-react';
import CallToAction from '../components/home/CallToAction';

const FAQPage: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);
  const categories = Array.from(new Set(faqs.map(faq => faq.category)));

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <>
      <Section className="pt-32 md:pt-40">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Frequently Asked <span className="text-primary">Questions</span>
          </h1>
          <p className="text-xl md:text-2xl text-neutral-300">
            Find answers to common questions about our AI product development consulting services
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {categories.map(category => (
            <div key={category} className="mb-12">
              <h2 className="text-2xl font-semibold mb-6">{category}</h2>
              <div className="space-y-4">
                {faqs.filter(faq => faq.category === category).map(faq => (
                  <div
                    key={faq.id}
                    className="border border-neutral-800 rounded-lg overflow-hidden"
                  >
                    <button
                      className="w-full text-left p-6 flex items-center justify-between hover:bg-neutral-900/50 transition-colors"
                      onClick={() => toggleFAQ(faq.id)}
                    >
                      <span className="font-medium text-lg">{faq.question}</span>
                      <ChevronDown
                        size={20}
                        className={`text-primary transition-transform ${
                          openId === faq.id ? 'rotate-180' : ''
                        }`}
                      />
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        openId === faq.id ? 'max-h-96' : 'max-h-0'
                      }`}
                    >
                      <p className="px-6 pb-6 text-neutral-300">{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Section>
      <CallToAction />
    </>
  );
};

export default FAQPage;